module.exports = __webpack_public_path__ + "static/media/expand.81b8ddf5.svg";